import i18n from '@/lang/i18n'
import { ConfigurationDefaultPortionResponse } from '@/modules/configurationModule/detail/automation/portions/services/configuration-portions.dto'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { portionsConfigurationServices } from '@/modules/configurationModule/detail/automation/portions/services/configuration-portions.service'
import { store } from '@/store/store'

export const columnsDefTextAutomationPortionsGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.sampleType'),
            colId: 'sampleType.description',
            field: 'sampleType',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true,
            cellRenderer: ({ value }: ICellRendererParams) => value ? `${value.code} | ${value.description}` : ''
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.topographicCode'),
            colId: 'topographicCode.description',
            field: 'topographicCode',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true,
            cellRenderer: ({ value }: ICellRendererParams) => value ? `${value.code} | ${value.description}` : ''
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.procedures'),
            colId: 'procedure.description',
            field: 'procedure',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true,
            cellRenderer: ({ value }: ICellRendererParams) => value ? `${value.code} | ${value.description}` : ''
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.portionType'),
            field: 'portionType.potName',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.portionNumber'),
            colId: 'portionNumber',
            field: 'numberOfPortionsToGenerate',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface AutomationPortionsGridState extends CrudModelPaginatorLaboratory<ConfigurationDefaultPortionResponse> {
    labId: number
}
export const initialAutomationPortionsGridState =
    (): AutomationPortionsGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.automation.defaultPortions',
        columnsDef: columnsDefTextAutomationPortionsGrid(),
        datasource: new PaginatorLaboratoryDatasource(portionsConfigurationServices, store.getters.labId),
        labId: store.getters.labId
    })
